/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/
import request from 'request';
import store from './store.js';
import actions from './actions';

let config = require('../settings/config.json');

const p = console.log



const fetchFeed = function (feed, offset, menu) {
  const { fetchFeed } = actions; //updateMenu
  // if(menu && (JSON.stringify(menu) !== JSON.stringify(feed.menu))){
  //   console.log('MENU CHANGED: WILL UPDATE MENU')
  //   feed.menu = menu
  //   store.dispatch(updateMenu(feed, menu))
  // }
  //TODO: the following line should be removed and the check should be done earlier
  if(feed.id == "search") return search(feed.lastRequest.query, offset, feed)

  store.dispatch(fetchFeed(feed, offset))
}

const search = function(query, offset, feed){
  if(query || feed.product==='landingpage' || (feed.menu && feed.menu.find(m=>m.value==='orders' && m.selected))){
    const {search} = actions;
    store.dispatch(search(query, offset, feed))
  }
}

const get = function (path, callback){
  request(window.location.origin + config.server[window.env].apiUrl + path, function (error, response, body) {
    if(!error && response.statusCode == 200){
      var res = JSON.parse(body)
      res = res && res.feed  && res.feed[0] ? res.feed[0] : (res[0] ? res[0] : res)
      var cRes = {response:response, body:res}
      if(callback){
        callback(error,cRes)
      }
    }

  })
}

const post = (path, body)=>{

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(body)
    };

    let url = config.server[window.env].url+config.server[window.env].apiUrl.slice(1)+path

    return fetch(url, requestOptions).then(response => response.json())

}

export {fetchFeed, get, post, search}
